var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, actions } from 'react-redux-form';

import { Icon } from "../../UI";
import { Translate } from "../../I18N";
import { getFileExtension } from "../../utils/getFileExtension";
import uniqueID from "../../../shared/uniqueID";

const getFileIcon = (file) => {
  const acceptedThumbnailExtensions = ['png', 'gif', 'jpg', 'jpeg'];
  let thumbnail = /*#__PURE__*/
  _jsx("span", { "no-translate": true }, void 0, /*#__PURE__*/
  _jsx(Icon, { icon: "file" }), " file"
  );


  if (file.filename && getFileExtension(file.filename) === 'pdf') {
    thumbnail = /*#__PURE__*/
    _jsx("span", { "no-translate": true }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "file-pdf" }), " pdf"
    );

  }

  if (file.url) {
    thumbnail = /*#__PURE__*/
    _jsx("span", {}, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "link" })
    );

  }

  if (
  !file.serializedFile &&
  file.filename &&
  acceptedThumbnailExtensions.indexOf(getFileExtension(file.filename.toLowerCase())) !== -1)
  {
    thumbnail = /*#__PURE__*/_jsx("img", { src: `/api/files/${file.filename}`, alt: file.originalname });
  }
  return thumbnail;
};

const fieldModel = (file, type, index) => {
  if (type === 'attachment') return `.attachments.${index}.originalname`;
  if (file._id) return `.documents.${index}.originalname`;
  return `.documents.${index}.originalFile.name`;
};







const mapDispatchToProps = (dispatch, ownProps) => {
  const { model, type } = ownProps;
  const path = type === 'attachment' ? `${model}.attachments` : `${model}.documents`;
  return bindActionCreators(
    {
      removeFile: (index) => actions.remove(path, index)
    },
    dispatch
  );
};

const connector = connect(null, mapDispatchToProps);




const MetadataFormFiles = ({ files = [], removeFile, type }) => /*#__PURE__*/
_jsx("div", { className: "attachments-list editor" }, void 0,
files.map((file, index) => {
  const attachmentClass = file._id ? 'attachment' : 'attachment new';
  return (/*#__PURE__*/
    _jsx("div", { className: attachmentClass }, file._id || uniqueID(), /*#__PURE__*/
    _jsx("div", { className: "attachment-thumbnail" }, void 0, getFileIcon(file)), /*#__PURE__*/
    _jsx("div", { className: "attachment-name" }, void 0, /*#__PURE__*/
    _jsx(Field, { model: fieldModel(file, type, index), updateOn: "blur" }, void 0, /*#__PURE__*/
    _jsx("input", { className: "form-control" })
    )
    ), /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "btn delete-supporting-file",
      onClick: () => removeFile(index) }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "trash-alt" }), "\xA0 ", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Delete file")
    )
    ));

})
);


const container = connector(MetadataFormFiles);
export { container as MetadataFormFiles };